/**
 * @typedef { object } TestIdObject
 * @property { string } data-testid - generated id for component
 */

import generateTestId from './generateTestId';

/**
 * This function generates props for html element in correct format
 * @example
 * const generateTestId = generateTestIdProps({ team, project });
 * return (<button {...generateTestId('my-button')}>Button</Button>);
 * @param { TestIdContext } props
 * @returns { generateTestIdProps~generateTestIdObjectFunction } generator function
 */
export default function generateTestIdProps({
  team,
  project
}) {
  const getTestId = generateTestId({
    team,
    project
  });

  /**
   * @callback generateTestIdProps~generateTestIdObjectFunction
   * @param {string} testId - component name
   * @returns { TestIdObject }
   */
  return testId => ({
    'data-testid': getTestId(testId)
  });
}
//# sourceMappingURL=generateTestIdProps.js.map